import {NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule} from "@angular/forms";
import { CoreDirectivesModule } from "@core/directives/directives";
import {TranslocoDirective} from "@jsverse/transloco";
import { NgSelectModule } from "@ng-select/ng-select";
 

@Component({
  selector: 'app-guideline-tile',
  standalone: true,
    imports: [
        CoreDirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        TranslocoDirective,
        NgIf,
        NgTemplateOutlet,
        NgClass,
        NgSelectModule
    ],
  templateUrl: './guideline-tile.component.html',
  styleUrl: './guideline-tile.component.scss'
})
export class GuidelineTileComponent implements OnInit{
    @Output() removeGuideline:EventEmitter<void> = new EventEmitter<void>();
    @Input() form: FormGroup;
    @Input() submitted: boolean = false;
    
    constructor(private hostFrom: FormGroupDirective) {
        this.form = this.hostFrom.form;
    }

    ngOnInit(): void {
        this.form = this.hostFrom.form;
    }

    onRemoveGuidelineClicked(){
        this.removeGuideline.emit();
    }
}
